import { styled } from '@mui/material';
// import { RouteImage } from '../../../assets/routeImage';
import { colors } from '../../../constants/colors';
import { motion } from 'framer-motion';


export const Container = styled('main')(({ theme }) => ({
    width: "100vw",
    minWidth: "auto",
    height: "100vh",
    // minHeight: "100vh",
    // paddingTop: "4rem",
    // background: `url(${process.env.REACT_APP_API_PATH}/login-background) no-repeat`,
    // backgroundSize: "cover",
    // backgroundPosition: "center",
    padding: "0 348px",
    overflow: "hidden",
    [theme.breakpoints.down('desktopXl')]: {
        width: "100%",
        padding: "0 156px"
    },
    [theme.breakpoints.down('desktop')]: {
        padding: "0 40px"
    },
    [theme.breakpoints.down('tablet')]: {
        height: "100%",
        minHeight: "100vh",
    },
    [theme.breakpoints.down('mobileXl')]: {
        padding: "0 10px"
    },
}))

export const MainBox = styled('div')(({ theme }) => ({
    width: "100%",
    height: "100%",
    minHeight: "100vh",
    display: "flex",
    justifyContent: 'flex-end',
    alignItems: "flex-end",
    [theme.breakpoints.down('tablet')]: {
        justifyContent: "center",
        alignItems: "center",
        height: "auto",
        padding: "2rem 0.3rem"
    }
}))

export const LoginBox = styled(motion.div)(({ theme }) => ({
    width: "100%",
    maxWidth: "524px",
    height: "auto",
    mixHeight: "734px",
    borderRadius: '8px',
    padding: '60px 48px',
    // border:"2px solid red",
    backgroundColor: colors.white,

    // display:"none",
    boxShadow: "0 10px 15px -3px rgba(0,0,0,0.10),0 4px 6px -4px rgba(0,0,0,0.10)",
    marginBottom: "136px",
    'div': {
        '&:nth-of-type(2)': {
            'h1': {
                lineHeight: "42px",
                color: colors.lampang_primary,
            }
        },
    },
    [theme.breakpoints.down('tablet')]: {
        height: "auto",
        maxHeight: "1000px",
        padding: "20px 20px",
        marginTop: "5rem",
        overflow: "auto",
    }
}))

export const FormAuthentication = styled('form')(({ theme }) => ({
    marginTop:"4rem",
    transform: "scale(.75)",
    width: "100%",
    height: '100%',
    [theme.breakpoints.down('sm')]: {
        transform: "scale(1)",
        marginTop:"0px",
    }
}))